import { useState } from "react";
import { NavLink } from "react-router-dom";

export default function SectionOfac({ _data }) {
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  if (!_data) {
    return null;
  }

  const handleOpenModal = (item) => {
    setDataModal(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDataModal(null);
  };

  return (
    <>
      <div className="section-full p-t120 p-b90 site-bg-gray tw-service-gallery-style3-area">
        <div className="services-gallery-block-outer3">
          <div className="container">
            <div className="section-head center wt-small-separator-outer">
              <div className="wt-small-separator site-text-primary">
                <div>{_data.title}</div>
              </div>
              <h3 className="wt-title">{_data.subtitle}</h3>
              <p
                className="section-head-text"
                style={{ fontSize: "16px", textAlign: "justify" }}
              >
                {_data.description}
              </p>
            </div>

            <div className="section-content">
              <div className="services-gallery-style3">
                <div className="row">
                  {Array.isArray(_data.feats) &&
                    _data.feats.map((item, index) => (
                      <div
                        key={item.key || index}
                        className="col-lg-4 col-md-6 mb-4 mt-5"
                      >
                        <div className="service-box-style3 h-100">
                          <div className="service-content">
                            <h3 className="service-title-large">
                              <span className="service-title-large-number">
                                {String(index + 1).padStart(2, "0")}
                              </span>
                              <p>{item.title}</p>
                            </h3>

                            <p>{item.summary}</p>

                            <NavLink
                              to="#"
                              className="site-button-2"
                              onClick={() => handleOpenModal(item)}
                            >
                              {_data.viewDetail}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            {showModal && dataModal && (
              <div
                className="modal-backdrop"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0, 0, 0, 0.55)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                  padding: "1rem",
                }}
              >
                <div
                  className="modal-content"
                  style={{
                    background: "#fff",
                    borderRadius: "12px",
                    width: "100%",
                    maxWidth: "860px",
                    maxHeight: "92vh",
                    overflowY: "auto",
                    position: "relative",
                    padding: "1.5rem",
                  }}
                >
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    aria-label="Cerrar"
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "12px",
                      border: "none",
                      background: "transparent",
                      fontSize: "1.8rem",
                      lineHeight: 1,
                    }}
                  >
                    &times;
                  </button>

                  <h3 className="mb-3">{dataModal.title}</h3>
                  {dataModal.details && (
                    <p className="text-muted">{dataModal.details}</p>
                  )}

                  <div className="row mt-4">
                    <div className="col-12 col-lg-7">
                      <div className="mb-3">
                        <strong>{_data.deliverables}:</strong>
                        <ul className="list-group list-group-flush mt-2">
                          {Array.isArray(dataModal.deliverables) &&
                            dataModal.deliverables.map((item, idx) => (
                              <li key={idx} className="list-group-item px-0">
                                {item}
                              </li>
                            ))}
                        </ul>
                      </div>

                      <div className="mb-2">
                        <strong>{_data.reqDocuments}:</strong>
                        <ul className="list-group list-group-flush mt-2">
                          {Array.isArray(dataModal.requiredDocs) &&
                            dataModal.requiredDocs.map((item, idx) => (
                              <li key={idx} className="list-group-item px-0">
                                {item}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>

                    <div className="col-12 col-lg-5 d-flex align-items-start justify-content-center mt-3 mt-lg-0">
                      {dataModal.image && (
                        <img
                          src={dataModal.image}
                          alt={dataModal.title}
                          style={{
                            width: "100%",
                            maxWidth: "320px",
                            borderRadius: "10px",
                            boxShadow: "0 6px 22px rgba(0, 0, 0, 0.2)",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
